import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import styled from 'styled-components'
import moment from 'moment'
import R from 'ramda'
import CheckinsActions from '../../Data/Redux/CheckinsRedux'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import Tool from '../../Components/ReportsComponents/Tool'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
export const Container = styled.div`
  width: ${props => props.normal ? 'auto' : '100%'};
`

const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class Checkins extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [{ id: '00', hour: '12 AM', total: 0 }, { id: '01', hour: '01 AM', total: 0 }, { id: '02', hour: '02 AM', total: 0 }, { id: '03', hour: '03 AM', total: 0 },
        { id: '04', hour: '04 AM', total: 0 }, { id: '05', hour: '05 AM', total: 0 }, { id: '06', hour: '06 AM', total: 0 }, { id: '07', hour: '07 AM', total: 0 },
        { id: '08', hour: '08 AM', total: 0 }, { id: '09', hour: '09 AM', total: 0 }, { id: '10', hour: '10 AM', total: 0 }, { id: '11', hour: '11 AM', total: 0 },
        { id: '12', hour: '12 PM', total: 0 }, { id: '13', hour: '01 PM', total: 0 }, { id: '14', hour: '02 PM', total: 0 }, { id: '15', hour: '03 PM', total: 0 },
        { id: '16', hour: '04 PM', total: 0 }, { id: '17', hour: '05 PM', total: 0 }, { id: '18', hour: '06 PM', total: 0 }, { id: '19', hour: '07 PM', total: 0 },
        { id: '20', hour: '08 PM', total: 0 }, { id: '21', hour: '09 PM', total: 0 }, { id: '22', hour: '10 PM', total: 0 }, { id: '23', hour: '11 PM', total: 0 }],
      checkOut: [],
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getCheckins } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'attendance/checkin')
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'attendance/checkin')
      }
    } else {
      getCheckins()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const { checkins, user, centers, fromCenter, centersInfo } = nextProps
    const newData = []
    const newCheckOut = []
    if (user === 'Director') {
      if (!R.isEmpty(checkins)) {
        const keys = Object.keys(checkins)
        keys.sort()
        keys.map((dtr) => {
          const activeIndex = R.findIndex(R.propEq('id', dtr))(newState.data)
          newState.data[activeIndex]['Check-in'] = checkins[dtr].checkin_count
          newState.data[activeIndex]['Check-out'] = checkins[dtr].checkout_count
        })
        this.setState({ newState })
      }
    } else if (!R.isEmpty(checkins)) {
      const keys = Object.keys(checkins)
      keys.sort()
      keys.map((key) => {
        const format = `${key}00`
        const hour = { hour: moment(format, 'hmm').format('hh A') }
        Object.keys(checkins[key]).map((item) => {
          if (centers.length > 0) {
            const { abbreviation } = centers.find(center => center.id === checkins[key][item].center_id)
            hour[abbreviation] = checkins[key][item].checkin_count
          }
        })
        newData.push(hour)
      })
      keys.map((key) => {
        const format = `${key}00`
        const hour = { hour: moment(format, 'hmm').format('hh A') }
        Object.keys(checkins[key]).map((item) => {
          if (centers.length > 0) {
            const { abbreviation } = centers.find(center => center.id === checkins[key][item].center_id)
            hour[abbreviation] = checkins[key][item].checkout_count
          }
        })
        newCheckOut.push(hour)
      })
      this.setState({ data: newData, checkOut: newCheckOut })
    } else if (centersInfo) {
      if (!R.isEmpty(centersInfo)) {
        const keys = Object.keys(centersInfo)
        keys.sort()
        keys.map((dtr) => {
          const activeIndex = R.findIndex(R.propEq('id', dtr))(newState.data)
          newState.data[activeIndex]['Check-in'] = centersInfo[dtr].checkin_count
          newState.data[activeIndex]['Check-out'] = centersInfo[dtr].checkout_count
        })
        this.setState({ newState })
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }


  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('attendance/checkin', this.props.activeCenter)
    } else {
      this.props.getCheckinsExcel()
    }
  }

  getBars = () => {
    const bars = this.props.centers.map((value, index) => {
      return (
        <Bar key={index} dataKey={value.abbreviation} stackId="a" fill={this.pickColor(value.abbreviation) ? COLORS[index % COLORS.length] : 'gray'} />
      )
    })
    return bars
  }

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] && (this.state.data[i][name] !== 0 && this.state.data[i][name] !== null)) {
        count++
      }
    }
    return count > 0
  }

  render() {
    const { checkins, user, centers, centersInfo, fromCenter } = this.props
    const { width, data, checkOut } = this.state
    return (
      <Container normal={(user === 'Director' || fromCenter)}>
        {(user === 'Director' || fromCenter) ?
          <ReportTemplate
            title="Distribución Checkins-Checkouts"
            onClick={this.download}
            date={{ initial: moment().subtract(1, 'months').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD') }}
            loading={!(data[0]['Check-in'] !== undefined)}
          >
            {data[0]['Check-in'] !== undefined &&
              <BarChart
                width={width < 763 ? 400 : 648}
                height={width < 763 ? 300 : 400}
                data={data}
                margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
              >
                <CartesianGrid vertical={false} />
                <XAxis dataKey="hour" />
                <YAxis />
                <Tooltip />
                <Legend content={<CustomizedLegend />} />
                <Bar dataKey="Check-in" fill="#bb4ab7" />
                <Bar dataKey="Check-out" fill="#2A517F" />
              </BarChart>
            }
          </ReportTemplate>
          :
          <Content>
            <ReportTemplate
              title="Distribución Checkins"
              date={{ initial: moment().subtract(1, 'months').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD') }}
              onClick={this.download}
              loading={!(centers.length > 0)}
            >
              {centers.length > 0 &&
              <BarChart
                width={width < 763 ? 400 : 648}
                height={width < 763 ? 300 : 400}
                data={data}
                margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
              >
                <CartesianGrid vertical={false} />
                <XAxis dataKey="hour" />
                <YAxis />
                <Tooltip content={<Tool withoutCurrency withoutTotal large />} />
                <Legend content={<CustomizedLegend />} />
                {this.getBars()}
              </BarChart>
              }
            </ReportTemplate>
            <ReportTemplate
              title="Distribución Checkouts"
              date={{ initial: moment().subtract(1, 'months').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD') }}
              onClick={this.download}
              loading={!(centers.length > 0)}
            >
              {centers.length > 0 &&
              <BarChart
                width={width < 763 ? 400 : 648}
                height={width < 763 ? 300 : 400}
                data={checkOut}
                margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
              >
                <CartesianGrid vertical={false} />
                <XAxis dataKey="hour" />
                <YAxis />
                <Tooltip content={<Tool withoutCurrency withoutTotal large />} />
                <Legend content={<CustomizedLegend />} />
                {this.getBars()}
              </BarChart>
              }
            </ReportTemplate>
          </Content>
        }
      </Container>
    )
  }
}


const mapStateToProps = ({ checkins, centerOptions, auth, centersInfo }) => ({
  checkins: checkins.get.results,
  centers: centerOptions.get.results,
  user: auth.user.role,
  centersInfo: centersInfo.checkins.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getCheckins: () => dispatch(CheckinsActions.getRequest({}, true)),
  getCheckinsExcel: () => dispatch(CheckinsActions.CheckinsExcelRequest({}, true)),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Checkins))



// WEBPACK FOOTER //
// ./src/Containers/Reports/Checkins.jsx